import axios from "axios";
import jwt_decode from "jwt-decode";
import { debounce } from "lodash";

import fetchEnv from "../../../utils/FetchEnv";
import { t } from "../../../utils/ResourceUtils";
export function getTimeLeftInSeconds(decodedToken) {
  return ~~(decodedToken?.exp - new Date().getTime() / 1000);
}

export function logout(_window = window) {
  _window.localStorage.clear();
  _window.sessionStorage.clear();
  _window.location.replace("/");
}

export function checkIsInExpiryTimeRange(timeLeft, from, to) {
  return timeLeft > from && to >= timeLeft;
}

export async function refreshTokenAsync(jwtToken, retryCount = 3, _window = window) {
  if (!navigator.onLine) {
    console.log("Network offline, skipping refresh token.");
    return;
  }

  try {
    const res = await axios.get(`${fetchEnv()?.REACT_APP_APIURL_ADMIN}/authservice/v1/refreshToken`, {
      headers: {
        Authorization: jwtToken,
        "Accept-Language": "en",
        "Content-Type": "application/json",
      },
    });
    _window.localStorage.setItem("loginResponse", JSON.stringify(res?.data));
  } catch (error) {
    console.log("RefreshToken error", error);

    if (retryCount > 0) {
      console.log(`Retrying... (${retryCount} attempts left)`);
      setTimeout(() => refreshTokenAsync(jwtToken, retryCount - 1), 2000); // Retry after 2 seconds
    } else {
      console.log("Max retry attempts reached. Logging out.");
      logout();
    }
  }
}

export async function refreshOrLogout({ isInExpiryTimeRange, jwtToken, timeLeftInSeconds, logout, refreshTokenAsync }) {
  if (isInExpiryTimeRange) {
    await refreshTokenAsync(jwtToken);
  } else if (timeLeftInSeconds < 0) {
    setTimeout(logout, 1000);
  }
}

export function setRefValue(ref, value) {
  ref.current = value;
}

export function getRefValue(ref) {
  return ref.current;
}

export const newDebouncedMouseMove = function ({ eventTriggeredRef }) {
  return debounce(async () => {
    if (!getRefValue(eventTriggeredRef)) {
      const token = JSON.parse(localStorage.getItem("loginResponse"));
      if (token) {
        const jwtToken = token?.object?.jwt;
        const decodedToken = jwt_decode(jwtToken);
        const timeLeftInSeconds = getTimeLeftInSeconds(decodedToken);

        refreshOrLogout({
          isInExpiryTimeRange: checkIsInExpiryTimeRange(timeLeftInSeconds, 0, 300),
          jwtToken,
          timeLeftInSeconds,
          logout,
          refreshTokenAsync,
        });
      }
      setRefValue(eventTriggeredRef, true);
      setTimeout(() => {
        setRefValue(eventTriggeredRef, false);
      }, 100); // set timeout to match debounce time
    }
  }, 100); // Wait for 0.1 seconds
};

export function getUpdateUserDataValues(data, tenantId) {
  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    managerEmailID: data.managerEmailID,
    securityAnswer1: data.secQuestions.securityAnswer1,
    securityAnswer2: data.secQuestions.securityAnswer2,
    securityAnswer3: data.secQuestions.securityAnswer3,
    securityQuestion1: data.secQuestions.securityQuestion1,
    securityQuestion2: data.secQuestions.securityQuestion2,
    securityQuestion3: data.secQuestions.securityQuestion3,
    tenantID: tenantId,
  };
}

export const closeDialog = ({ userData, setShowProfileDialog, setSelectedAvatar, setDisableBtn }) => {
  setShowProfileDialog(false);
  setSelectedAvatar(userData?.userPicURL);
  setDisableBtn(false);
};

export const handleSubmit = async ({
  data,
  tenantId,
  setShowProfileDialog,
  setShowAlert,
  setToast,
  userInfoFun,
  updateUserDataByID,
}) => {
  const values = getUpdateUserDataValues(data, tenantId);
  try {
    const resp = await updateUserDataByID(values);
    if (resp.data.statusCode === 200) {
      setShowProfileDialog(false);
      setShowAlert(true);
      setToast({
        alertType: "success",
        message: t("cm.update_profile_success"),
      });
      userInfoFun();
    }
  } catch (err) {
    setShowAlert(true);
    setToast({
      alertType: "danger",
      message: t("cm.update_profile_fail"),
    });
    if (err.response.status === 401) logout();
  }
};
